export var options = {
  attributionWidthOffset: 55
};

export default options;



//////////////////
// WEBPACK FOOTER
// ./node_modules/esri-leaflet/src/Options.js
// module id = 255
// module chunks = 0